<template>
    <PopoverRight ref="popoverContent" width="500px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">{{title}}</h1>
            <el-form class="form-container" :rules="rules" :model="formList" ref="topicValidateForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">话题名称</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item  prop="topic_name">
                            <el-input v-model="formList.topic_name" placeholder="请输入话题名称（30个字符以内）"></el-input>                   
                        </el-form-item>
                    </div>
                </div>
                 <div class="form-item">
                    <div class="form-label">
                        <span class="label">话题描述</span>
                    </div>
                    <div class="form-input-item">
                        <el-form-item prop="topic_desc">
                            <el-input v-model="formList.topic_desc" type="textarea" placeholder="输入话题描述，不填时将生成默认描述内容（0-200字符）"></el-input>              
                        </el-form-item>
                    </div>
                </div>
                <div class="align-center">
                    <el-button @click="hideMenu">取消</el-button>
                    <el-button type="primary" @click="submitForm('topicValidateForm')" >确定</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'

import {getBankDetail,ediBankItem,bankItemAdd} from '@/service/topicBank'

export default {
    name: 'add',
    components: {
        PopoverRight,
    },
    props: {
        callback: Function,
    },
    data () {
        return {
            title:"新增话题",
            formList:{
                topic_name:'',
                topic_desc:'',
            },
            rules: {
                topic_name: [
                    { required: true, message: '请填写话题名称', trigger: 'blur' },
                    { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                ],
                topic_desc: [
                    { min: 0, max: 200, message: '长度在 0 到 200 个字符', trigger: 'blur' }
                ],
               
            },
            topicId:null,

        }
    },
    mounted(){

    },
    methods: {
        /** 打开右侧悬浮层 */
        openMenu (id) {
            if(id && id>0){
                this.title = "编辑话题";
                this.topicId = id;
                getBankDetail(id).then(data => {
                    this.formList = data;
                });
            }else{
                this.title = "新增话题";
                this.topicId = null;
                this.formList = {
                    topic_name:'',
                    topic_desc:'',
                }
            }
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.resetForm()
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
            this.$refs.topicValidateForm && this.$refs.topicValidateForm.clearValidate()
        },
        resetForm () {
            this.formList = {
                topic_name:'',
                topic_desc:'',
            }
        },
         submitForm (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    if(this.topicId){
                        ediBankItem(this.topicId,this.formList).then((data) => {
                            this.$message({
                                message: '编辑成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.hideMenu()
                            this.callback && this.callback();
                        }).catch(err => {
                            this.$message({
                                message: err.message || '编辑失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    }else{
                        bankItemAdd(this.formList).then((data) => {
                            this.$message({
                                message: '添加成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.hideMenu()
                            this.callback && this.callback();
                        }).catch(err => {
                            this.$message({
                                message: err.message || '添加失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    }
                    
                } else {
                    return false
                }
            })
        },
    }
}
</script>
<style scoped>

</style>